import { Station } from '@mi-front/core';
import { NullState } from '@mi-front/ui';
import { FormattedMessage } from 'react-intl';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { AvgUpload } from '../../audit-support-files/avg-upload/AvgUpload';
import { BcrUpload } from '../../audit-support-files/bcr-upload/BcrUpload';
import { LtxUpload } from '../../audit-support-files/ltx-upload/LtxUpload';
import { AudioSchedulesAscUpload } from '../audio-schedules-asc/AudioSchedulesAscUpload';
import { AudioSchedulesPlkUpload } from '../audio-schedules-plk/AudioSchedulesPlkUpload';
import { UploadAudioView } from '../audios/UploadAudioView';
import { PntSchedulesCsvUpload } from '../pnt-schedules-csv/PntSchedulesCsvUpload';

export function UploadView(p: { station: Station }) {
  const { path, ...rest } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/audios`} render={() => <UploadAudioView station={p.station} />} />
      <Route
        path={`${path}/ad-schedules-plk`}
        render={() => <AudioSchedulesPlkUpload station={p.station} />}
      />
      <Route
        path={`${path}/ad-schedules-asc`}
        render={() => <AudioSchedulesAscUpload station={p.station} />}
      />
      <Route
        path={`${path}/pnt-schedules-csv`}
        render={() => <PntSchedulesCsvUpload station={p.station} />}
      />
      <Route path={`${path}/bcr-upload`} render={() => <BcrUpload station={p.station} />} />
      <Route path={`${path}/ltx-upload`} render={() => <LtxUpload station={p.station} />} />
      <Route path={`${path}/avg-upload`} render={() => <AvgUpload station={p.station} />} />
      <Route
        render={() => (
          <NullState className="p-6">
            <FormattedMessage
              id="audit.filesUpload.selectFileType"
              defaultMessage="Seleccione un tipo de archivo del menú lateral"
            />
          </NullState>
        )}
      />
    </Switch>
  );
}
